<template>
    <div class="item-question">
        <button @click="openModal()" class="item-question-btn btn btn-primary item-question-btn item-question-btn--1">Noch Fragen?</button>
        <div class="item-question-modal-wrapper">
            <div class="modal fade item-question-modal" tabindex="-1" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title h3">Noch Fragen?</div>
                            <button type="button" @click="closeModal()" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-3">
                                    <div class="input-unit">
                                        <input type="text" class="form-control item-question-id" disabled :value="currentVariation.item.id">
                                        <label>Artikel-ID</label>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-9">
                                    <div class="input-unit">
                                        <input type="text" class="form-control item-question-name" disabled :value="currentVariation.texts.name1">
                                        <label>Artikel-Name</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="input-unit">
                                        <textarea class="form-control item-question-message" placeholder="Ihre Frage" required rows="5"></textarea>
                                        <label>Ihre Frage*</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="input-unit">
                                        <input type="email" value="" placeholder="Ihre E-Mail" required class="form-control item-question-mail">
                                        <label>Ihre E-Mail*</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-12 text-right">
                                    <button @click="send()" class="btn btn-primary item-question-btn item-question-btn--2">Senden</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const NotificationService = require("ceres/app/services/NotificationService");
    import TranslationService from "ceres/app/services/TranslationService";

    export default {
        inject: {
            itemId: {
                default: null
            }
        },
        methods:{
            openModal(){
                $('.item-question-modal-wrapper').detach().appendTo("body");
                $('.item-question-modal').modal("show");
            },

            closeModal(){
                $('.item-question-modal').modal("hide");
                $('.item-question-modal-wrapper').detach().appendTo(".item-question");
            },

            send(){

                $(".item-question-modal-wrapper .has-error").removeClass("has-error");

                let isAllFilled = true;

                $(".item-question-modal-wrapper .input-unit [required]").each(function (index, item) {
                    if ($(item).val() == "") {
                        $(item).closest(".input-unit").addClass("has-error");
                        isAllFilled = false;
                    }
                });

                if (isAllFilled) {

                    const mailObj =
                        {
                            userMail: $(".item-question-mail").val(),
                            name: $(".item-question-name").val(),
                            id: $(".item-question-id").val(),
                            message: $(".item-question-message").val(),
                            subject: "Artikelfrage"
                        };

                    $.ajax({
                        url: window.location.origin+"/rest/funsporthandel/customer/contact/mail",
                        type: "POST",
                        async: true,
                        data: {
                            contactData: mailObj,
                            template: "ODFunsporthandel::Customer.Components.Contact.QuestionMail"
                        },
                        success: function (data, textStatus, jqXHR) {
                            // success
                            NotificationService.success(
                                TranslationService.translate("Ceres::Template.contactSendSuccess")
                            ).closeAfter(10000);

                            $('.item-question-modal').modal("hide");
                            $('.item-question-modal-wrapper').detach().appendTo(".item-question");
                        },
                        error: function (data) {
                        }
                    });

                }

            }
        },
        computed: {
            currentVariation(){
                return this.$store.getters[this.itemId+'/currentItemVariation'];
            }
        }
    }
</script>
